import React from 'react';
import SignupForm from '../SignupForm/SignupForm';

function SectionUsers(props) {
  const { rootClassName, onSubmit, inProgress, termsAndConditions, signupError } = props;
  return (
    <SignupForm
      className={rootClassName}
      onSubmit={onSubmit}
      inProgress={inProgress}
      termsAndConditions={termsAndConditions}
      signupError={signupError}
    />
  );
}

export default SectionUsers;
